import { ref, watch } from 'vue'

export function useViewMode(key: string = 'viewMode') {
  const viewMode = ref(localStorage.getItem(key) || 'single')

  watch(viewMode, (newValue) => {
    localStorage.setItem(key, newValue)
  })

  return viewMode
} 